/**
 * Validation par étape du wizard — fonction pure (pas de setState).
 * @param {number} step
 * @param {object} formData
 * @param {import('i18next').TFunction} t
 * @returns {{ errors: object, isValid: boolean }}
 */
export function validateWizardStep(step, formData, t) {
	const newErrors = {};
	let isValid = true;

	if (step === 1) {
		if (!formData.nom_projet) {
			newErrors.nom_projet = t('validation.required');
			isValid = false;
		} else if (formData.nom_projet && !/^[a-z0-9-]*$/.test(formData.nom_projet)) {
			newErrors.nom_projet = t('validation.nomProjetInvalid');
			isValid = false;
		}
		if (!formData.nom_pass) {
			newErrors.nom_pass = t('validation.required');
			isValid = false;
		}
		if (!formData.territoire) {
			newErrors.territoire = t('validation.required');
			isValid = false;
		}
	}

	if (step === 2) {
		if (!formData.nom_emetteur) {
			newErrors.nom_emetteur = t('validation.required');
			isValid = false;
		}
		if (!formData.reference_emetteur) {
			newErrors.reference_emetteur = t('validation.required');
			isValid = false;
		}
		if (!formData.adresse_postale) {
			newErrors.adresse_postale = t('validation.required');
			isValid = false;
		}
		if (!formData.code_postal) {
			newErrors.code_postal = t('validation.required');
			isValid = false;
		}
		if (!formData.ville) {
			newErrors.ville = t('validation.required');
			isValid = false;
		}
		if (!formData.pays || formData.pays === '') {
			newErrors.pays = t('validation.selectPays');
			isValid = false;
		} else if (formData.pays === 'Autre' && (!formData.pays_autre || formData.pays_autre === '')) {
			newErrors.pays_autre = t('validation.required');
			isValid = false;
		}
		if (!formData.site_public) {
			newErrors.site_public = t('validation.required');
			isValid = false;
		} else if (
			formData.site_public &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.site_public)
		) {
			newErrors.site_public = t('validation.siteWebUrl');
			isValid = false;
		}
		if (!formData.domaine) {
			newErrors.domaine = t('validation.required');
			isValid = false;
		} else if (formData.domaine && !/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/i.test(formData.domaine)) {
			newErrors.domaine = t('validation.domaine');
			isValid = false;
		}
		if (!formData.email_public) {
			newErrors.email_public = t('validation.required');
			isValid = false;
		} else if (
			formData.email_public &&
			!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.email_public)
		) {
			newErrors.email_public = t('validation.email');
			isValid = false;
		}
		if (!formData.email_reception) {
			newErrors.email_reception = t('validation.required');
			isValid = false;
		} else if (
			formData.email_reception &&
			!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.email_reception)
		) {
			newErrors.email_reception = t('validation.email');
			isValid = false;
		}
		if (
			formData.facebook &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.facebook)
		) {
			newErrors.facebook = t('validation.facebookUrl');
			isValid = false;
		}
		if (
			formData.youtube &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.youtube)
		) {
			newErrors.youtube = t('validation.youtubeUrl');
			isValid = false;
		}
		if (
			formData.instagram &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.instagram)
		) {
			newErrors.instagram = t('validation.instagramUrl');
			isValid = false;
		}
		if (formData.x && !/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.x)) {
			newErrors.x = t('validation.xUrl');
			isValid = false;
		}
	}

	if (step === 3) {
		if (formData.is_transport === 'oui') {
			if (formData.transport_operator === 'Autre' && !formData.transport_operator_other) {
				newErrors.transport_operator_other = t('validation.required');
				isValid = false;
			}
		}
	}

	if (step === 4) {
		if (formData.alimentation_base_touristique === 'oui') {
			if (formData.editeur_plateforme === 'Autre' && !formData.editeur_plateforme_autre) {
				newErrors.editeur_plateforme_autre = t('validation.required');
				isValid = false;
			}
			if (formData.frequence_synchronisations === 'Autre' && !formData.frequence_synchronisations_autre) {
				newErrors.frequence_synchronisations_autre = t('validation.required');
				isValid = false;
			}
		}
	}

	if (step === 5) {
		if (formData.support_physique === 'oui') {
			if (formData.identifiant_1 === 'autre' && !formData.identifiant_1_autre) {
				newErrors.identifiant_1_autre = t('validation.required');
				isValid = false;
			}
			if (formData.identifiant_2 === 'autre' && !formData.identifiant_2_autre) {
				newErrors.identifiant_2_autre = t('validation.required');
				isValid = false;
			}
		}
	}

	if (step === 6) {
		if (formData.prestataires_equipes === 'oui') {
			if (!Array.isArray(formData.type_lecture) || formData.type_lecture.length === 0) {
				newErrors.type_lecture = t('validation.typeLecture');
				isValid = false;
			}
		}
	}

	if (step === 7) {
		if (formData.front_domain && !/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/i.test(formData.front_domain)) {
			newErrors.front_domain = t('validation.frontDomain');
			isValid = false;
		}
		if (formData.front_domain && formData.front_domain_booking === 'oui' && !formData.front_domain_operator) {
			newErrors.front_domain_operator = t('validation.required');
			isValid = false;
		}
	}

	if (step === 8) {
		if (
			formData.facebook_pass &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.facebook_pass)
		) {
			newErrors.facebook_pass = t('validation.facebookPassUrl');
			isValid = false;
		}
		if (
			formData.youtube_pass &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.youtube_pass)
		) {
			newErrors.youtube_pass = t('validation.youtubePassUrl');
			isValid = false;
		}
		if (
			formData.instagram_pass &&
			!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.instagram_pass)
		) {
			newErrors.instagram_pass = t('validation.instagramPassUrl');
			isValid = false;
		}
		if (formData.x_pass && !/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.x_pass)) {
			newErrors.x_pass = t('validation.xPassUrl');
			isValid = false;
		}
	}

	if (step === 9) {
		if (formData.formulaire_inscription === 'oui') {
			if (!formData.url_formulaire) {
				newErrors.url_formulaire = t('validation.required');
				isValid = false;
			} else if (
				formData.url_formulaire &&
				!/^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(formData.url_formulaire)
			) {
				newErrors.url_formulaire = t('validation.urlFormulaire');
				isValid = false;
			}
		}
	}

	if (step === 10) {
		const cur = formData.finance_currencies_iso;
		if (!Array.isArray(cur) || cur.length === 0) {
			newErrors.finance_currencies_iso = t('validation.financeCurrencies');
			isValid = false;
		}
	}

	if (step === 12) {
		const hasCoordinateurContact =
			formData.contact_coordinateur_lastname ||
			formData.contact_coordinateur_firstname ||
			formData.contact_coordinateur_email ||
			formData.contact_coordinateur_tel1 ||
			formData.contact_coordinateur_tel2;
		if (hasCoordinateurContact) {
			['contact_coordinateur_lastname', 'contact_coordinateur_firstname'].forEach((field) => {
				if (!formData[field]) {
					newErrors[field] = t('validation.required');
					isValid = false;
				}
			});
			if (
				formData.contact_coordinateur_email &&
				!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.contact_coordinateur_email)
			) {
				newErrors.contact_coordinateur_email = t('validation.email');
				isValid = false;
			}
		}
		const hasTechniqueContact =
			formData.contact_technique_lastname ||
			formData.contact_technique_firstname ||
			formData.contact_technique_email ||
			formData.contact_technique_tel1 ||
			formData.contact_technique_tel2;
		if (hasTechniqueContact) {
			['contact_technique_lastname', 'contact_technique_firstname'].forEach((field) => {
				if (!formData[field]) {
					newErrors[field] = t('validation.required');
					isValid = false;
				}
			});
			if (
				formData.contact_technique_email &&
				!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.contact_technique_email)
			) {
				newErrors.contact_technique_email = t('validation.email');
				isValid = false;
			}
		}
		const hasDataContact =
			formData.contact_data_lastname ||
			formData.contact_data_firstname ||
			formData.contact_data_email ||
			formData.contact_data_tel1 ||
			formData.contact_data_tel2;
		if (hasDataContact) {
			['contact_data_lastname', 'contact_data_firstname'].forEach((field) => {
				if (!formData[field]) {
					newErrors[field] = t('validation.required');
					isValid = false;
				}
			});
			if (
				formData.contact_data_email &&
				!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.contact_data_email)
			) {
				newErrors.contact_data_email = t('validation.email');
				isValid = false;
			}
		}
		const hasComptaContact =
			formData.contact_compta_lastname ||
			formData.contact_compta_firstname ||
			formData.contact_compta_email ||
			formData.contact_compta_tel1 ||
			formData.contact_compta_tel2;
		if (hasComptaContact) {
			['contact_compta_lastname', 'contact_compta_firstname'].forEach((field) => {
				if (!formData[field]) {
					newErrors[field] = t('validation.required');
					isValid = false;
				}
			});
			if (
				formData.contact_compta_email &&
				!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.contact_compta_email)
			) {
				newErrors.contact_compta_email = t('validation.email');
				isValid = false;
			}
		}
		const hasOtherContact =
			formData.contact_other_function ||
			formData.contact_other_lastname ||
			formData.contact_other_firstname ||
			formData.contact_other_email ||
			formData.contact_other_tel1 ||
			formData.contact_other_tel2;
		if (hasOtherContact) {
			['contact_other_function', 'contact_other_lastname', 'contact_other_firstname'].forEach((field) => {
				if (!formData[field]) {
					newErrors[field] = t('validation.required');
					isValid = false;
				}
			});
			if (
				formData.contact_other_email &&
				!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(formData.contact_other_email)
			) {
				newErrors.contact_other_email = t('validation.email');
				isValid = false;
			}
		}
	}

	if (step === 13) {
		newErrors.formules = [];
		formData.formules.forEach((formule, index) => {
			let hasFormula =
				formule.package ||
				formule.reference ||
				formule.duree ||
				formule.periode ||
				formule.tarifAdulte ||
				formule.tarifEnfant ||
				formule.accompagnants;
			if (index > 0) {
				hasFormula = true;
			}
			if (hasFormula) {
				['package', 'reference', 'duree', 'periode'].forEach((field) => {
					if (!formule[field] || formule[field] === '') {
						newErrors.formules.push(index);
						isValid = false;
					}
				});
			}
		});
	}

	return { errors: newErrors, isValid };
}
